import React, { lazy, Suspense, useEffect, useState } from 'react'

import { useNavigate } from "react-router-dom";

import { pageRoutes } from '../../routes/pageRoutes';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { APIServices } from '../../hooks/fetchAPI';
import { useDispatch, useSelector } from 'react-redux';
import { storeUserDetails } from '../../redux/userSlice';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { FaQ, FaQuestion } from 'react-icons/fa6';
import { storageApi } from '../../contant';
const FaqModal = lazy(() => import('../Applicant/Modal/FaqModal'));
const FacebookModal = lazy(() => import('../Applicant/Modal/FacebookModal'));

const LoginPage = () => {
    const images = [];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = React.useState(false);
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [rememberMe, setRememberMe] = React.useState(true);
    const [error, setError] = useState(false)
    const [alertmsg, setAlertMsg] = useState('')
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(false);
    const [showFaq, setShowFaq] = useState(false);
    const [showFacebookModal, setShowFacebookModal] = useState(true);
    const [getAds, fetchContent] = useState([]);
    const [imageSources, setImageSources] = useState(images);
    const [isLoading, setIsLoading] = useState(false);

    const user = useSelector((state) => state.user.userData);
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === imageSources.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(timer);
    }, [imageSources.length]);

    useEffect(() => {
        adsContent();
        if (user?.ads_limit >= 4) {
            setShowFacebookModal(false);
        }
        const checkToken = localStorage.getItem("access_token")
        if (checkToken) {
            navigate("/applicant/dashboard")
        }

    }, []);

    useEffect(() => {
        if (getAds.length > 0) {
            setImageSources(getAds.map(ad => `${storageApi}${ad.file}`));
        } else {
            setImageSources(images);
        }
    }, [getAds]);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };



    const adsContent = async () => {
        setIsLoading(true);
        try {
            const response = await APIServices.get({ url: `/show-ads` });
            if (response && response.status === 200) {
                fetchContent(response?.data || []);
            } else {
                console.error("Failed to fetch ads content", response);
            }
        } catch (error) {
            console.error("Failed to fetch ads content", error);
        } finally {
            setIsLoading(false);
        }
    }


    const handleLogin = async () => {
        setShowFacebookModal(false);
        if (!email || !password) {
            setError(true)
            setAlertMsg('Please enter email and password')
            return;
        }

        setLoader(true)
        setSuccess(false)
        setError(false)

        let data = {
            email: email,
            password: password
        }

        try {
            const response = await APIServices.post({ url: `/login`, payload: data });
            if (response.status === 200) {
                if (response?.data?.user?.admin_status !== null) {
                    setError(true)
                    setAlertMsg("User is Admin, User cannot login as applicant.");
                    return
                }

                setAlertMsg('');
                localStorage.setItem('access_token', response.data?.token);
                localStorage.setItem('ads_limit', 1);
                dispatch(
                    storeUserDetails({
                        id: response.data?.user?.id || 1,
                        name: response.data?.user?.name,
                        email: response.data?.user?.email,
                        session_key: response.data?.token,
                        admin_status: response.data?.user?.admin_status || null,
                    })
                );
                setSuccess(true)
                setAlertMsg(response?.data?.message)
                navigate('/applicant/dashboard');
            } else {
                setError(true)
                setAlertMsg("Invalid credentials. Please check your email and password.");
            }

        } catch (e) {
            setError(true);
            setAlertMsg(e?.response?.data?.message || "An error occurred. Please try again.");
        } finally {
            setLoader(false)
        }
    }

    return (
        <div className='h-screen w-full bg-slate-50 gap-2 flex flex-row items-center justify-center relative'>
            <Suspense fallback={<div></div>}>
                <FacebookModal visible={showFacebookModal} onClose={() => {
                    setShowFacebookModal(false);
                    const newLimit = (parseInt(localStorage.getItem('ads_limit')) || 0) + 1;
                    localStorage.setItem('ads_limit', newLimit);
                    dispatch(
                        storeUserDetails({
                            ...user,
                            ads_limit: newLimit,
                        })
                    );
                }} />
                <FaqModal visible={showFaq} onClose={() => setShowFaq(false)} />
            </Suspense>


            <div onClick={() => setShowFaq(true)} className='flex flex-row h-fit bg-white shadow-sm  rounded-md absolute top-4 right-4 p-2 gap-2 items-center justify-center' >
                <FaQuestion />
                <span className='text-[#2e6b1f] font-semibold cursor-pointer hover:text-[#556fa8]'>FAQ's</span>
            </div>

            <div className='flex flex-row w-fit h-fit bg-white gap-2 shadow-sm shadow-stone-700 drop-shadow-md  rounded-lg p-8  items-center justify-center'>
                {/* Hide image on mobile */}
                <div className='max-w-[500px] w-full max-h-[400px] h-full flex flex-col items-center justify-center hidden sm:flex cursor-pointer '>
                    {isLoading ? <CircularProgress /> :
                        <img className='h-full w-full object-center rounded-md' src={imageSources[currentImageIndex]} alt={`SixEleven Center`} />}
                </div>

                <div>

                </div>

                <div className='max-w-[600px] w-full max-h-[600px] h-full p-4 border-[#839f55] flex flex-col gap-2 border-l'>

                    <div className='flex flex-col items-center gap-2'>

                        <AccountCircleIcon sx={{ color: '#556fa8' }} fontSize="large" />

                        <div className='self-center'>
                            <img className="default_logo lazyloaded" src="https://www.sixelevenbpo.com/wp-content/uploads/2020/05/six-eleven-center-logo.png" alt="six-eleven-center-logo" data-ll-status="loaded" />
                        </div>

                        <h1 className='text-xs text-[#556fa8] font-semibold self-center'>Hello! Let's get started</h1>
                    </div>

                    <div className='max-w-[400px] w-full flex flex-col self-center gap-3'>

                        <FormControl sx={{ width: '100%' }}>
                            <span className='mb-3 font-medium text-[#556fa8]'>Email</span>
                            <TextField
                                id="outlined-required"
                                type='email'
                                placeholder="type here..."
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </FormControl>

                        <FormControl sx={{ width: '100%' }}>

                            <div className='w-full flex flex-row items-center justify-between gap-2 my-3'>
                                <span className='font-medium text-[#556fa8]'>Password</span>
                                <span onClick={() => navigate('/forgot-password')} className='text-[#388E3C] underline font-light cursor-pointer text-sm hover:text-[#556fa8]'>Forgot Password?</span>
                            </div>

                            <OutlinedInput
                                id="outlined-adornment-password"
                                placeholder="type here..."
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={
                                                showPassword ? 'hide the password' : 'display the password'
                                            }
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                        >
                                            {showPassword ?

                                                <VisibilityOff sx={{
                                                    color: '2e6b1f',
                                                    '&.Mui-checked': {
                                                        color: '#2e6b1f',
                                                    },
                                                }}
                                                /> :
                                                <Visibility sx={{
                                                    color: '#2e6b1f',
                                                    '&.Mui-checked': {
                                                        color: '#2e6b1f',
                                                    },
                                                }}
                                                />
                                            }
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>

                        {success && <Alert severity='success'>{alertmsg}</Alert>}
                        {error && <Alert severity='error'>{alertmsg}</Alert>}

                        <div onClick={handleLogin} className='w-full font-lexend bg-[#388E3C] flex flex-col items-center justify-center rounded py-2 cursor-pointer text-white font-medium hover:bg-[#556fa8]'>
                            {loader ? <CircularProgress color='white' /> : <span>Sign In</span>}
                        </div>

                        {/* <span className='text-black font-light text-sm font-lexend'>Don’t have an account?</span> */}

                        <div onClick={() => navigate(`/register/1`)} className='w-full font-lexend bg-white flex flex-col items-center justify-center border border-[#2e6b1f] rounded py-2 cursor-pointer text-[#2e6b1f] font-medium hover:bg-[#556fa8] hover:text-white'>
                            <span>Register Account</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage